export default __webpack_public_path__ + "static/media/education.9ed8b538.svg";